import { render, staticRenderFns } from "./RelatoriosConvenio.vue?vue&type=template&id=f5b6518c"
import script from "./RelatoriosConvenio.vue?vue&type=script&lang=js"
export * from "./RelatoriosConvenio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports